import React, { useState, useCallback, useContext } from "react";
import axios from "axios";
import { useAlert } from "react-alert";
import { useDropzone } from "react-dropzone";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import { Button } from "@mui/material";

import context from "../../../../../../../context/auth-context";
import { Code } from "@mui/icons-material";

function Dropzone(props) {
  const authContext = useContext(context);
  const [file, setFile] = useState(null);
  const alerting = useAlert();

  // const handleSubmit = useCallback(async (file) => {
  //   if (file) {
  //     try {
  //       const formData = new FormData();
  //       formData.append("fileupl", file, file.name);

  //       // const response = await fetch("https://ai_search.stl-horizon.com/api/upload", {
  //       //   method: "POST",
  //       //   body: formData,
  //       //   redirect: "follow",
  //       // });

  //       const response = await axios.post("https://ai_search.stl-horizon.com/api/upload",formData);
  //       if (response) {
  //         console.log(formData, "success");
  //         alert.show("Uploaded successfully", { type: "success" });
  //       } else {
  //         throw new Error("Upload failed");
  //       }
  //     } catch (error) {
  //       alert.show(error.message, { type: "error" });
  //     }
  //   }
  // }, []);

  // const handleSubmit = useCallback(
  //   async (file) => {
  //     if (file) {
  //       try {
  //         const formData = new FormData();
  //         formData.append("fileupl", file, file.name);

  //         const response = await axios.post(
  //           "https://ai_search.stl-horizon.com/api/upload",
  //           formData,
  //           {
  //             headers: {
  //               "Content-Type": file.type,
  //               "x-filename": file.name,
  //             },
  //           }
  //         );

  //         if (response.status === 200) {
  //           axios.post(`/resources/indexed-files/ebr-files`, {
  //             formData,
  //             folder_id: 732,
  //             user_name: authContext.userName,
  //             headers: {
  //               Authorization: authContext.accessToken,
  //               "Company-Code": authContext.companyCode,
  //               "Company-Id": authContext.companyId,
  //               "User-Id": authContext.userId,
  //             },
  //           });
  //           console.log(response, "success");
  //           alert("Successully Uploaded!");
  //           alerting.show("Uploaded successfully", { type: "success" });
  //         } else {
  //           throw new Error("Upload failed");
  //         }
  //       } catch (error) {
  //         alerting.show(error.message, { type: "error" });
  //         alert("Error uploading");
  //       }
  //     } else {
  //       // alert.show("No file selected", { type: "error" });
  //       alert("There was an error");
  //     }
  //   },
  //   [alert]
  // );

  const handleSubmit = useCallback(
    async (file) => {
      if (!file) {
        alert("There is no fileselected");
        return;
      }

      try {
        const formData = new FormData();
        formData.append("fileupl", file, file.name);

        // First axios post call
        const uploadResponse = await axios.post(
          "https://ai_search.stl-horizon.com/api/upload",
          formData,
          {
            headers: {
              "Content-Type": file.type,
              "x-filename": file.name,
            },
          }
        );

        // Handle upload response
        if (uploadResponse) {
          alert("Uploaded successfully");
        }

        // // Second axios post call
        // const indexResponse = await axios.post(
        //   `/resources/indexed-files/ebr-files`,

        //   formData,
        //   {
        //     folder_id: 732,
        //     user_name: authContext.userName,
        //     headers: {
        //       Authorization: authContext.accessToken,
        //       "Company-Code": authContext.companyCode,
        //       "Company-Id": authContext.companyId,
        //       "User-Id": authContext.userId,
        //     },
        //   }
        // );

        // // Handle index response
        // if (indexResponse) {
        //   console.log(uploadResponse, "success");
        //   alert("Successfully Uploaded!");
        //   alerting.show("Uploaded successfully", { type: "success" });
        // } else {
        //   throw new Error("Indexing failed");
        // }
      } catch (error) {
        console.error(error);
        alerting.show(error.message, { type: "error" });
        alert("Error uploading");
      }
    },
    [authContext, alerting]
  );

  const onDrop = useCallback(
    (acceptedFiles) => {
      const selectedFile = acceptedFiles[0];
      setFile(selectedFile);
      handleSubmit(selectedFile);
    },
    [handleSubmit]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div className="col-md-4">
      <section className="container">
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          <div className="text-center" style={{ marginTop: "5px" }}>
            <Button
              fullWidth
              color="success"
              size="small"
              variant="contained"
              startIcon={<AttachFileRoundedIcon />}
            >
              Attach File
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Dropzone;
